import React, { type ReactNode } from 'react';

/**
 * @deprecated use StrongWrapper from @atlassian/jira-onboarding-core' instead
 */
export const BoldWrapper = ({ children }: { children: ReactNode }) => <b>{children}</b>;
